<template>
  <div>
      <div style="width: 100%; text-align: left;">
        <h1 v-if="workOrderData.sale_number !== null">Order#: {{workOrderData.sale_number}}</h1>
        <el-tabs 
              @tab-click="tabIsClicked"
              v-model="activeTab">
            <el-tab-pane 
                v-if="workOrderData.id === 0 && workOrderData.work_order_history.length>0 && !$store.getters.getPreferenceProps.sale_form_reduced" 
                :label="'Import From Past'" 
                name="0">
                <History 
                    :wo_index="wo_index"
                    @swapTab="activeTab='1'" 
                    :workOrderData="workOrderData"/>
            </el-tab-pane>
            <el-tab-pane :label="'Promise Details'" name="1">
                <div style="display: flex; flex-direction: row;">
                    <div style="width: 60%;">
                        <PromiseDetail 
                        :wo_confirmed="wo_confirmed" 
                        :workOrderData="workOrderData"/>                    
                    </div>
                    
                    <div v-if="!$store.getters.getPreferenceProps.work_order_planner_not_required" style="margin-left: 2%; width: 38%">
                        <DisplayWOLoad :workOrderData="workOrderData"/>
                    </div>
                </div>
                
            </el-tab-pane>
            <el-tab-pane :label="'Measurements'" v-if="$store.getters.getPreferenceProps.customer_measurement_required" name="2">
                <MeasurementForm 
                    v-loading="workOrderData.measurement_loading"
                    :item_category_id="workOrderData.category_id"
                    :customer_measurement_profile="workOrderData.customer_measurement_profile"
                />
            </el-tab-pane>
            <el-tab-pane :label="'Style Choices'" name="3">
                
                <div v-if="workOrderData.custom_style_sheet !== null && workOrderData.custom_style_sheet.id">
                    <CustomStyle :customer_style_sheet="workOrderData.custom_style_sheet"/>
                </div>
                <!----><el-tabs 
                    v-else-if="workOrderData.style_list.filter(t => t.material).length>0"
                    v-model="activeTab_1" type="border-card">
                    <el-tab-pane 
                        :label="'Regular Styles'" 
                        name="1">
                            <StyleList 
                                :workOrderData="workOrderData"
                                :style_list="workOrderData.style_list.filter(t => !t.material)"/>
                    </el-tab-pane>
                    <el-tab-pane 
                        :label="'Accessories'" 
                        name="2">
                            <StyleList 
                                :style_list="workOrderData.style_list.filter(t => t.material)"/>
                    </el-tab-pane>
                </el-tabs>
                <StyleList 
                    v-else
                    :style_list="workOrderData.style_list"/>
            </el-tab-pane>
            <el-tab-pane v-if="!$store.getters.getPreferenceProps.work_order_production_stage_tab_not_required" :label="'Production Stages'" name="4">
                
                <ProcessList 
                    :process_list="workOrderData.process_list"/>
            </el-tab-pane>
            <el-tab-pane v-if="workOrderData.id>0 && !shortcut && $store.getters.getPreferenceProps.customer_measurement_required" :disabled="workOrderData.current_process === -1" :label="'Trial Window'" name="5">
                <div style="text-align: left;">
                    <el-checkbox 
                        size="small"
                        @change="$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: workOrderData, activeTab: '4'})"
                        :disabled="!workOrderData.all_work_orders_in_store"
                        v-model="workOrderData.trial_form.take_trial">
                        Open Trial Window
                    </el-checkbox>
                    <span v-if="!workOrderData.all_work_orders_in_store" style="color: red;">
                        <br>
                        Some of the work-orders are not in store yet!!!
                    </span>
                </div>
                <br>
                  
                <TrialWindow @printTrial="printTrial" :workOrderData="workOrderData"/>
            </el-tab-pane>
            <el-tab-pane v-if="!$store.getters.getPreferenceProps.work_order_sketch_board_not_required" :label="'Sketch Board'" name="6">
                <Whiteboard :sale_item_index="sale_item_index" :workOrderData="workOrderData"/>
            </el-tab-pane>
            <el-tab-pane :label="'Images'" name="7">
                <ImageList 
                    :image_list="workOrderData.image_list"/>
            </el-tab-pane>
            <el-tab-pane v-if="$store.getters.getPreferenceProps.customer_measurement_required" :label="'Profile Images'" name="8">
                <CustomerPhotos 
                    :image_list="workOrderData.customer_profile_images"/>
            </el-tab-pane>
            <el-tab-pane v-if="$store.getters.getPreferenceProps.customer_measurement_required" :label="'Copy WOs'" name="9">
                <CopyItems 
                    :sale_item_index="sale_item_index"
                    :workOrderData="workOrderData"/>
            </el-tab-pane>
            
        </el-tabs>
    </div>
  </div>
</template>

<script>
import History from './History'
import PromiseDetail from './PromiseDetail'
import ProcessList from './ProcessList'
import StyleList from './StyleList'
import ImageList from './ImageList'
import TrialWindow from './TrialWindow'
import MeasurementForm from '../CustomerMaster/Form/MeasurementProfile/Index.vue'
import CopyItems from './CopyItems'
import CustomerPhotos from './CustomerPhotos'
import DisplayWOLoad from './DisplayWOLoad.vue'
import CustomStyle from './CustomStyle.vue'

import ProductionList from './ProductionList'

export default {
    components: {CustomStyle, DisplayWOLoad, CustomerPhotos, CopyItems, ProductionList, History, PromiseDetail, ProcessList, MeasurementForm, StyleList, ImageList, TrialWindow},
    props: ['workOrderData', 'wo_confirmed', 'sale_item_index', 'wo_index', 'shortcut'],
    data() {
        return {
            activeTab: '1',
            activeTab_1: '1'
        }
    },
    computed: {
        getActiveTab() {
            return this.activeTab
        }
    },
    methods: {
        printTrial($event) {
            this.$emit('printTrial', $event)
        },
        tabIsClicked(tab, event) {
            /*if(this.getActiveTab === '2' 
                || this.getActiveTab === '3' 
                    || this.getActiveTab === '4')
            
            if(this.getActiveTab === '2' 
                && this.workOrderData.customer_measurement_profile.length === 0) {
                    //this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } else if(this.getActiveTab === '3' 
                && this.workOrderData.style_list.length === 0) {
                    this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } else if(this.getActiveTab === '4' 
                && this.workOrderData.process_list.length === 0) {
                    this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } */
            //
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.workOrderData.id>0 && this.$store.getters.getSaleMasterDataProps.item_list[this.sale_item_index].extra_charge_unit_rate>0) {
                //this.activeTab = '3'
                //this.tabIsClicked(null, null)
            }           
        }, 300);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/Wrapper.vue